import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchCurrentTerms } from "@/server/services/termsService";
import { useTcGateState } from "@/zustand/TcGateState";
import { QUERY_KEYS } from "@/config/queryKeys";
import useAuthSession from "@/middleware/hooks/useAuthSession";

export function useTcVersionCheck() {
  const { isLoggedIn } = useAuthSession();
  const acceptedVersion = useTcGateState((s) => s.acceptedVersion);
  const required = useTcGateState((s) => s.required);
  const setTcRequired = useTcGateState((s) => s.setTcRequired);

  const { data: currentTerms } = useQuery({
    queryKey: QUERY_KEYS.termsCurrent,
    queryFn: fetchCurrentTerms,
    enabled: isLoggedIn && !required,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
  });

  useEffect(() => {
    if (!currentTerms || !isLoggedIn || required) {
      return;
    }
    if (acceptedVersion === null || currentTerms.version !== acceptedVersion) {
      setTcRequired(currentTerms.version);
    }
  }, [currentTerms, isLoggedIn, required, acceptedVersion, setTcRequired]);
}
